import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  useTheme,
  Button
} from '@mui/material'
import React from 'react'
import { PrimaryButton } from '../PrimaryButton'

export const ConfirmationDialog = ({
  open,
  handleClose,
  handleConfirm,
  agreeText = 'Agree',
  title,
  content
}) => {
  const theme = useTheme()
  const darkGrey = theme.palette.grey[800]
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='sm'
      fullWidth
    >
      <Box
        p={3}
        backgroundColor={theme.palette.sunrise3.main}
        position='relative'
      >
        <DialogTitle id='alert-dialog-title' style={{ textAlign: 'center' }}>
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              height: 40,
              borderColor: darkGrey,
              color: darkGrey,
              '&:hover': {
                borderColor: darkGrey,
                color: darkGrey,
                backgroundColor: 'transparent'
              }
            }}
            variant='outlined'
            disableElevation
            onClick={handleClose}
          >
            Cancel
          </Button>
          <PrimaryButton onClick={handleConfirm}>{agreeText}</PrimaryButton>
        </DialogActions>
      </Box>
    </Dialog>
  )
}
